<template>
  <div class="flex-grow-1 d-flex flex-column">
    <div class="container-fluid">
      <div class="d-flex align-items-center flex-wrap mb-3">
        <h2 class="page-heading mr-auto">График изменения баланса</h2>
        <div class="d-flex align-items-center flex-wrap justify-content-end history-range">
          <label class="mb-0 mr-2 text-nowrap">От</label>
          <datepicker
            v-model="filters.from"
            class="history-range__input mr-3"
          />
          <label class="mb-0 mr-2 text-nowrap">До</label>
          <datepicker
            v-model="filters.to"
            class="history-range__input mr-3"
          />
          <el-select v-model="days" size="small" class="w-auto mr-2">
            <el-option :value="7" label="7 дней"/>
            <el-option :value="14" label="14 дней"/>
            <el-option :value="30" label="30 дней"/>
            <el-option :value="90" label="90 дней"/>
          </el-select>
          <button
            class="btn btn-link p-0 history-range__reset"
            type="button"
            @click="clearRange"
          >Сбросить даты</button>
        </div>
      </div>
    </div>
    <div class="container-fluid flex-grow-1 d-flex flex-column">
      <div class="card flex-grow-1">
        <div class="card-body">
          <balance-history-chart
            class="h-100"
            :endpoint="'billing/balance/history'"
            :days="days"
            :from="filters.from"
            :to="filters.to"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BalanceHistoryChart from '@/components/billing/balance-history-chart.vue'
  import Datepicker from '@/components/datepicker.vue'

  export default {
    components: { BalanceHistoryChart, Datepicker },
    data () {
      return {
        days: 30,
        filters: {
          from: null,
          to: null,
        },
      }
    },
    methods: {
      clearRange () {
        this.filters.from = null
        this.filters.to = null
      },
    },
  }
</script>

<style lang="scss" scoped>
  .history-range__input {
    width: 150px;
  }

  .history-range__reset {
    font-size: 0.875rem;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/billing/cash-flow/history.vue